import abstractModel from '../../core/ShopModel';

const resource = 'retailers/orders';

const ShopOrderModelMC = abstractModel(resource);

ShopOrderModelMC.getFields = async (params = {}) => (
  ShopOrderModelMC.get(params, { path: `${resource}/fields` })
);

ShopOrderModelMC.getPendingOrders = async () => (
  ShopOrderModelMC.get({}, { path: 'retailers/pending_orders' })
);

ShopOrderModelMC.updateOrder = async (orderWebId, body, isFormData = false) => {
  if (isFormData) {
    const formData = body instanceof FormData ? body : new FormData();
    if (!(body instanceof FormData)) {
      Object.entries(body).forEach(([key, value]) => {
        formData.append(`order[${key}]`, value);
      });
    }
    if (!formData.get('id')) {
      formData.append('id', orderWebId);
    }
    return ShopOrderModelMC.save(formData);
  }

  return ShopOrderModelMC.save({
    id: orderWebId,
    order: body
  });
};

ShopOrderModelMC.exportOrders = async (searchParams = {}) => {
  const encodedParams = new URLSearchParams(searchParams).toString();
  const params = { agent: { email: ENV.CURRENT_AGENT_EMAIL } };
  return ShopOrderModelMC.post(params, {
    path: `${resource}/export${encodedParams ? `?${encodedParams}` : ''}`
  });
};

ShopOrderModelMC.exportDetailedOrders = async (searchParams = {}) => {
  const encodedParams = new URLSearchParams(searchParams).toString();
  const params = { agent: { email: ENV.CURRENT_AGENT_EMAIL } };
  return ShopOrderModelMC.post(params, {
    path: `${resource}/detailed_export${encodedParams ? `?${encodedParams}` : ''}`
  });
};

export default ShopOrderModelMC;
